import React, { useMemo } from 'react';
import { Clock3, Link2 } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';
import { Tooltip } from '../../components/ui/Tooltip';

const shortenPreviewUrl = (url) => {
  if (!url) {
    return '';
  }

  try {
    const parsed = new URL(url);
    const path = parsed.pathname === '/' ? '' : parsed.pathname;
    return `${parsed.host}${path}`;
  } catch {
    return url;
  }
};

export const PreviewSessionInfo = ({ previewUrl, remainingTime }) => {
  const { t } = useI18n();
  const displayUrl = useMemo(() => shortenPreviewUrl(previewUrl), [previewUrl]);

  if (!previewUrl) {
    return null;
  }

  return (
    <div className="flex h-8 min-w-0 max-w-[min(100%,22rem)] items-center overflow-hidden rounded-lg bg-[#F3F4F6] dark:bg-white/[0.06]">
      <Tooltip content={displayUrl || t('previewLinkLabel')} position="bottom" className="min-w-0">
        <a
          href={previewUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex h-full min-w-0 items-center gap-1.5 px-2.5 text-neutral-600 transition hover:bg-black/[0.04] hover:text-neutral-900 dark:text-muted dark:hover:bg-white/[0.04] dark:hover:text-text"
        >
          <Link2 size={13} className="shrink-0 text-neutral-400" />
          <span className="truncate text-[11px] font-medium">{t('previewTempLink')}</span>
        </a>
      </Tooltip>
      {remainingTime ? (
        <>
          <span className="h-4 w-px shrink-0 bg-neutral-200 dark:bg-border" aria-hidden="true" />
          <Tooltip content={t('previewExpiresTimeLabel')} position="bottom">
            <span
              className="inline-flex h-full shrink-0 items-center gap-1.5 px-2.5 text-neutral-500 dark:text-muted"
              aria-label={`${t('previewTimeRemaining')} ${remainingTime}`}
            >
              <Clock3 size={13} className="shrink-0 text-neutral-400" />
              <span className="text-[11px] font-semibold tabular-nums text-neutral-800 dark:text-text" dir="ltr">
                {remainingTime}
              </span>
              <span className="hidden text-[10px] text-neutral-400 sm:inline">{t('previewTimeRemaining')}</span>
            </span>
          </Tooltip>
        </>
      ) : null}
    </div>
  );
};
